import React from 'react';
import { Stack } from '@mui/material';
import { SelectOption } from 'global';
import { FormSectionHeaderProps } from 'components/shared/FormSectionHeader';
import { FormSectionHeader } from 'components/shared/FormSectionHeader/FormSectionHeader';
import { Finance } from './finance/Finance';
import { FinanceFormValues } from './types';

interface Props<Value extends string> extends FormSectionHeaderProps<Value> {
  financeAmount: number;
  netInvoiceAmount: number;
  maxApprovalAmount: number;
  isFPOptionsLoading: boolean;
  financeProgramOptions: SelectOption[];
  onFetchFinanceProgram: (programId: string) => Promise<Partial<FinanceFormValues['financeQuote']>>;
}

export const FinanceStructure = <Value extends string>({
  financeAmount,
  netInvoiceAmount,
  maxApprovalAmount,
  isFPOptionsLoading,
  financeProgramOptions,
  onFetchFinanceProgram,
  ...headerProps
}: Props<Value>) => {
  return (
    <Stack gap="0.5rem">
      <FormSectionHeader {...headerProps} />

      <Finance
        financeAmount={financeAmount}
        netInvoiceAmount={netInvoiceAmount}
        maxApprovalAmount={maxApprovalAmount}
        isFPOptionsLoading={isFPOptionsLoading}
        onFetchFinanceProgram={onFetchFinanceProgram}
        financeProgramOptions={financeProgramOptions}
      />
    </Stack>
  );
};
